<template>
  <div class="fanlist">
    <van-tabs v-model="active" title-active-color="#3A3A3A" color="#3A3A3A" @click="onClick" sticky>
      <van-tab title="关注">
        <!-- <van-search placeholder="搜索用户或名字" shape="round" v-model="value" /> -->
        <van-list
        v-model="loading"
        :finished="finished"
        finished-text="已加载全部"
        @load="onLoad"
        >
        <div slot="loading" class="list-loading">
          <img :src="img.loading" />
        </div>
        <van-row type="flex" justify="space-between" v-for="(item,index) in list" :key="'list_' + item.id">
         <van-col span="4" @click="goMy(item.id)">
          <img class="listhand" :src="item.headimg_url==''?img.avatar:item.headimg_url">
        </van-col>
        
        <van-col span="19" offset="1" v-if="item.intro==''" @click="goMy(item.id)">
          <div class="activename">
            {{item.user_name}}
          </div>
        </van-col>
        
        <van-col span="19" offset="1" v-else @click="goMy(item.id)">
          <div class="membername">{{item.user_name}}</div>
          <div class="sourtime">
           {{item.intro}}
         </div>
       </van-col>
       <van-col v-if="item.is_follow==0" class="bintright" span="4">
        <van-button class="follow" icon="plus" color="#3A3A3A" size="small" @click="follow(index,3,item.id)" :data-code="item.id">关 注</van-button>
      </van-col>
      <van-col class="bintright" span="4" v-else>
        <van-button class="inter" v-if="item.is_inter" @click="follow(index,0,item.id)" :data-code="item.id">互相关注</van-button>
        <van-button class="inter" v-else @click="follow(index,0,item.id)" :data-code="item.id">已 关 注</van-button>
      </van-col>
    </van-row>
  </van-list>
</van-tab>
<van-tab title="粉丝">
  <van-list
  v-model="loading"
  :finished="finished"
  finished-text="已加载全部"
  @load="onLoad"
  >
  <div slot="loading" class="list-loading">
    <img :src="this.img.loading" />
  </div>
  <van-row type="flex" justify="space-between" v-for="(item,index) in list" :key="'list_' + item.id">

   <van-col span="4" @click="goMy(item.id)">
    <img class="listhand" :src="item.headimg_url==''?img.avatar:item.headimg_url">
  </van-col>

  <van-col span="19" offset="1" v-if="item.intro==''" @click="goMy(item.id)">
    <div class="activename">
      {{item.user_name}}
    </div>
  </van-col>
  
  <van-col span="19" offset="1" v-else @click="goMy(item.id)">
    <div class="membername">{{item.user_name}}</div>
    <div class="sourtime">
     {{item.intro}}
   </div>
 </van-col>
 <van-col class="bintright" span="4">
   <van-button class="inter" v-if="item.is_inter"  @click="follow(index,1,item.id)">互相关注</van-button>
   <van-button class="follow"  v-else icon="plus" color="#3A3A3A" size="small"  @click="follow(index,2,item.id)" :data-code="item.id">关 注</van-button>
 </van-col>
</van-row>
</van-list>
</van-tab>
</van-tabs>
</div>
</template>
<script>
  import list from '../../../api/member/memberinfo';
  import follow from '../../../api/content';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import { Tab, Tabs,Row, Col, Button,Search,List  } from "vant";
  export default {
    data () {
      return {
        active: 0,
        value:'',
        loading: false,
        finished: false,
        list:[],
        params:{
          login_user_id: '',
          user_id: '',
          media_id: 6,
          page:1,
          size:12
        },
        img:{
          loading: require('../../../assets/img/loading_lexus.gif'),
          avatar: require('../../../assets/img/lexus/default.png'),
          member_bg: require('../../../assets/img/lexus/my/member_bg.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      this.weburl=process.env.VUE_APP_URL
      this.params.user_id=this.$route.params.id
      if(this.$route.query.type=="1"){
        this.active=1
        var apppar={
        title:'粉丝'
      }
      this.$appService.changeTitle(apppar)
      }else{
        this.active=0
        var apppar={
        title:'关注'
      }
      this.$appService.changeTitle(apppar)
      }
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      var params={
        event_code: '关注列表',
        event_id: this.params.user_id,
        title: '',
        value: '',
        path: '/Lexus/My/MyFans.vue',
        user_id: this.user ? this.user.id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
    },
    methods: {

      follow(index,inter,id){
        if(inter==2||inter==3){
          var interd=1
        }else{
          var interd=2
        }
        follow.Follow({follow_user_id: id, type: interd,media_id: 6}).then(res => {
          if(res.data.state == 1) {

            for(var i=0;i<this.list.length;i++){
              if(this.list[i].id==id){
                if (inter == 0) {
                  if (this.list[i].is_follow == 0) {
                    // this.list[i].is_follow = 1
                    this.$set(this.list[i],"is_follow", 1)
                    this.list[i].is_inter = true
                  } else {
                    // this.list[i].is_follow = 0
                    this.$set(this.list[i],"is_follow",0)
                    this.list[i].is_inter = false
                  }
                } else if (inter == 1) {
                  this.list[i].is_inter = false
                } else if (inter == 2) {
                  this.list[i].is_inter = true
                  if (this.list[i].is_follow == 0) {
                    // this.list[i].is_follow = 1
                    this.$set(this.list[i],"is_follow", 1)
                  } else {
                    // this.list[i].is_follow = 0
                    this.$set(this.list[i],"is_follow", 0)
                  }
                }else if (inter == 3) {
                  if (this.list[i].is_follow == 0) {
                    // this.list[i].is_follow = 1
                    this.$set(this.list[i],"is_follow", 1)
                  } else {
                    this.$set(this.list[i],"is_follow", 0)
                    // this.list[i].is_follow = 0
                  }
                }
              }
            }

          }
        })
      },
      onClick(title){
        this.list=[]
        this.active=title
        this.params.page=1
        this.finished = false
        
      },
      goMy(id){
        var params={
          url:this.weburl+'/lexus/my/other/'+id+'?source='+this.source ,
          isReturn: true 
        }
        this.$appService.openWebView(params)
      },
      onLoad(){
        if(this.active==0){

          setTimeout(() => {
            this.params.login_user_id=this.user.id
            list.getMyFollow(this.params).then(res => {
              this.list.push.apply(this.list, res.data.data.data)
              this.params.page += 1
              this.loading = false
              if(res.data.data.data.length == 0) {
                this.finished = true
              }
            })
          }, 500);
        }else{

          setTimeout(() => {
            this.params.login_user_id=this.user.id
            list.getMyFans(this.params).then(res => {
              this.list.push.apply(this.list, res.data.data.data)
              this.params.page += 1
              this.loading = false
              if(res.data.data.data.length == 0) {
                this.finished = true
              }
            })
          }, 500);
        }
        
      },
    }, 
    components: {
      [Row.name]: Row,
      [Col.name]: Col,
      [Tabs.name]: Tabs,
      [Tab.name]: Tab,
      [Button.name]: Button,
      [Search.name]:Search,
      [List.name]:List
    }
  }
</script>

<style lang="scss">
.fanlist{
  padding: 0 20px;
  .bintright{
    text-align:right;
    .inter{
      background-color: #F3F9FF;
      color: #728FC4;
    }
  }
  [class*=van-hairline]::after{
    border-top: 0 solid #ebedf0;
  }
  .van-button{
    min-width: 1.6rem;
    height: 28px;
    font-size: 12px;
    line-height: 2;
    padding: 0;
  }
  .sourtime{
    font-size: 12px;
    color: #9A9A9A;
  }
  .listhand{
    width:45px;
    height:45px;
  }
  .membername{
    font-size: 15px;
    font-weight: bold;
  }
  .activename{
    font-size: 15px;
    font-weight: bold;
    line-height: 3;
    color: #605C6B;
  }
  .van-row{
    margin-top: 20px;
  }
  .follow{
    vertical-align: super;
  }
  .van-button--small{
    height: 24px;
      // padding: 0 8px;
      line-height: 20px;
      border-radius: 1px;
      vertical-align: middle;
    }
    .van-button__icon{
      font-size: 10px;
    }
    .van-button__text{
      font-size: 11px;
    }
  }
</style>
